import React from 'react';
import { Avatar } from '@onward-delivery/design';
import { orgInitials } from './utils';
import { OrgHeaderRow, OrgName, OrgSubtitle } from './blocks';

// Figma's avatar is 60px navy with 28px initials; the library's sizes stop at 64px, so the size
// and colors are overrides (cn/twMerge lets them win over the defaults).
const AVATAR_CLASSES = 'h-[60px] w-[60px] bg-[#024791] text-[28px] font-extrabold text-white';

const OrgHeader = ({ name }) => (
    <OrgHeaderRow>
        <div className="onward-design">
            <Avatar alt={name} fallback={orgInitials(name)} className={AVATAR_CLASSES} />
        </div>
        <div>
            <OrgName>{name}</OrgName>
            <OrgSubtitle>Corporate Account</OrgSubtitle>
        </div>
    </OrgHeaderRow>
);

export default OrgHeader;
